/** Resolve a file under `public/` against Vite's `base` (prod `/`, staging `/staging/web/`). */
export function publicAsset(path: string, base: string = import.meta.env.BASE_URL): string {
  const prefix = (base || '/').endsWith('/') ? (base || '/') : `${base}/`;
  return `${prefix}${path.replace(/^\//, '')}`;
}
